<template>
    <div class="row order-info">
        <div class="col-md-12">
            <span
                class="text-underline cursor-pointer text-muted"
                style="position: absolute; top: -25px"
                @click="$router.back()"
                ><i class="fa fa-arrow-left" aria-hidden="true"></i> Go
                back</span
            >
            <div class="row">
                <div class="col">
                    <h3 v-if="user.is_demo">Invoice #INV-12345</h3>
                    <h3 v-else>Invoice #{{ invoiceInfo?.invoice_number }}</h3>
                </div>
                <div
                    class="btn-group inline-btns col"
                    role="group"
                    aria-label="Basic example"
                >
                    <button
                        type="button"
                        class="btn btn-secondary"
                        :disabled="previousInvoice == null"
                        @click="viewInvoice(previousInvoice)"
                    >
                        Previous
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        :disabled="nextInvoice == null"
                        @click="viewInvoice(nextInvoice)"
                    >
                        Next
                    </button>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-2">
                            <label>Customer:</label>
                        </div>
                        <div class="col-md-10">
                            <span class="d-block">{{
                                invoiceInfo?.location?.name
                            }}</span>
                            <span class="d-block">{{
                                invoiceInfo?.location?.address
                            }}</span>
                            <span class="d-block"
                                >{{ invoiceInfo?.location?.city }}
                                {{ invoiceInfo?.location?.state }}
                                {{ invoiceInfo?.location?.zip_code }}</span
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label>Delivery Address:</label>
                        </div>
                        <div class="col-md-10">
                            <span>{{ invoiceInfo?.location?.name }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label>Source:</label>
                        </div>
                        <div class="col-md-10">
                            <span
                                @click="viewOrder(invoiceInfo.order)"
                                class=""
                                :class="
                                    invoiceInfo?.invoice_origin?.substring(
                                        0,
                                        2
                                    ) == 'SO'
                                        ? 'hyperlink font-weight-bold'
                                        : ''
                                "
                            >
                                {{ invoiceInfo?.invoice_origin }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-2">
                            <label>Invoice Date:</label>
                        </div>
                        <div class="col-md-10">
                            <span>{{ invoiceInfo?.invoice_date }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2 text-truncate">
                            <label>Payment Terms:</label>
                        </div>
                        <div class="col-md-10">
                            <span>{{ invoiceInfo?.payment_terms }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label>Reference:</label>
                        </div>
                        <div class="col-md-10">
                            <span>{{ invoiceInfo?.reference }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <h5>Invoice Lines</h5>
            <table class="table table-responsive table-striped">
                <thead class="thead-light">
                    <tr>
                        <th>Description</th>
                        <th class="text-right" style="width: 10em">Quantity</th>
                        <th class="text-right" style="width: 10em">
                            Unit Cost
                        </th>
                        <th class="text-right" style="width: 10em">Taxes</th>
                        <th class="text-right" style="width: 10em">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in invoiceInfo?.invoice_line_items"
                        :key="item.id"
                    >
                        <td>{{ item.description }}</td>
                        <td class="text-right">{{ item.quantity }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(item.unit_cost) }}
                        </td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(item.taxes) }}
                        </td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(item.total) }}
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="border-0" colspan="3">&nbsp;</td>
                        <td class="subtotal text-right">
                            <label>GRAND TOTAL</label>
                        </td>
                        <td class="subtotal text-right">
                            <h6>
                                ${{ $filters.moneyFormat(invoiceInfo?.total) }}
                            </h6>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-0" colspan="3">&nbsp;</td>
                        <td class="subtotal text-right">
                            <label>AMOUNT DUE</label>
                        </td>
                        <td class="subtotal text-right">
                            <h6>
                                ${{
                                    $filters.moneyFormat(
                                        invoiceInfo?.amount_due
                                    )
                                }}
                            </h6>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="col-md-6">
            <h5>Invoice Products</h5>
            <table class="table table-responsive table-striped">
                <thead class="thead-light">
                    <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>SN/LN</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in invoiceInfo?.invoice_products"
                        :key="item.id"
                    >
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.sn_ln }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-12 pt-3 pb-5">
            <h5>Shipment Information:</h5>
            <!-- <label>SHIPPING FREE DELIVERY: {{ invoiceInfo?.invoice_shipment.tracking_number }}</label> -->
            <div class="row">
                <div class="col-md-2">
                    <label>Tracking Number:</label>
                </div>
                <div class="col-md-10">
                    <span class="d-block">{{
                        invoiceInfo?.invoice_shipment?.tracking_number
                    }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <label>Carrier:</label>
                </div>
                <div class="col-md-10">
                    <span class="d-block">{{
                        invoiceInfo?.invoice_shipment?.carrier
                    }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <label>Shipment Date:</label>
                </div>
                <div class="col-md-10">
                    <span class="d-block">{{
                        invoiceInfo?.invoice_shipment?.shipment_date
                    }}</span>
                </div>
            </div>
        </div>
        <br /><br /><br />
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: ["id"],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let invoiceInfo = computed(function () {
            return store.state.invoiceInfo;
        });
        let orderInfo = computed(function () {
            return store.state.orderInfo;
        });

        function getOrderByOrderNumber(orderNum) {
            store.dispatch("getOrderByOrderNumber", orderNum);
        }

        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });

        onMounted(() => {});

        return {
            store,
            user,
            invoiceInfo,
            orderInfo,
            getOrderByOrderNumber,
            currentLocation,
        };
    },
    data() {
        return {
            nextInvoice: null,
            previousInvoice: null,
        };
    },
    mounted() {
        this.store.dispatch("getInvoiceById", this.id);
        if (this.store.state.allInvoices.length == 0) {
            this.store
                .dispatch("getAllInvoices", {
                    location_id: this.currentLocation.id,
                    page_type: "invoices",
                })
                .then(() => {
                    this.mapNextPrevious();
                });
        } else {
            this.mapNextPrevious();
        }
    },
    methods: {
        mapNextPrevious() {
            for (let x = 0; x < this.store.state.allInvoices.length; x++) {
                if (this.store.state.allInvoices[x].id == this.id) {
                    if (this.store.state.allInvoices[x - 1] != undefined) {
                        this.previousInvoice =
                            this.store.state.allInvoices[x - 1].id;
                    }
                    if (this.store.state.allInvoices[x + 1] != undefined) {
                        this.nextInvoice =
                            this.store.state.allInvoices[x + 1].id;
                    }
                    break;
                }
            }

            console.log(this.nextInvoice);
            console.log(this.previousInvoice);
        },
        viewOrder(order) {
            if (order.order_number.substring(0, 2) == "SO") {
                // this.$router.push({ name: 'orderInfo', params: {id: order.id, order_number: order.order_number} })
                const routeData = this.$router.resolve({
                    name: "orderInfo",
                    params: { id: order.id, order_number: order.order_number },
                });
                window.open(routeData.href, "_blank");
            }
        },
        viewInvoice(invoice) {
            console.log(invoice);
            // this.setInvoiceInfo(invoice);
            this.$router.replace({
                name: "invoiceInfo",
                params: { id: invoice },
            });
        },
    },
};
</script>
<style scoped>
.inline-btns {
    width: fit-content;
    margin: auto;
    gap: 10px;
    max-width: 300px;
}

.inline-btns .btn-secondary {
    background-color: #e43f38;
    border: solid 1px #e43f38;
}
</style>
